module.exports = __webpack_public_path__ + "static/media/rj_result_lkyw3.0517f381.png";